import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in Manage Client procedure */
const changePasswordScheme = Yup.object().shape({
    newPassword: Yup.string()
        .required('New password must be filled')
        .max(60, 'Checklist name have limitation of 60 characters')
        .min(8, 'Password must be 8 characters at minimum!')
        .max(15, 'Password must be 15 characters at maximum!')
        .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}/,
            'Password must contain uppercase, lowercase, number, special character and ranging from 8-15 characters'
        )
        .oneOf(
            [Yup.ref('confirmPassword'), null],
            'New Password and Confirm Password should match'
        ),

    currentPassword: Yup.string()
        .required('current password is required')
        .min(8, 'Password must be 8 characters at minimum!')
        .max(15, 'Password must be 15 characters at maximum!')
        .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}/,
            'Password must contain uppercase, lowercase, number, special character and ranging from 8-15 characters'
        ),
    confirmPassword: Yup.string()
        .required('confirm password is required')
        .min(8, 'Password must be 8 characters at minimum!')
        .max(15, 'Password must be 15 characters at maximum!')
        .matches(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}/,
            'Password must contain uppercase, lowercase, number, special character and ranging from 8-15 characters'
        )
        .oneOf(
            [Yup.ref('newPassword'), null],
            'New Password and Confirm Password should match'
        ),
});

export { changePasswordScheme };
